class ImageToggleSwitch extends HTMLElement {
  constructor() {
    super();

    this.checkboxEl = this.querySelector('input');
    this.onChangeHandler = this.onChange.bind(this);
    this.productGrid = document.querySelector('#ProductGridWrapper');
  }

  connectedCallback() {
    this.checkboxEl = this.querySelector('input');

    // 👇 read from data attribute
    const defaultLifestyle = this.dataset.defaultLifestyle === 'true';
    this.checkboxEl.checked = defaultLifestyle;

    this.init();
    this.checkboxEl.addEventListener('change', this.onChangeHandler);
  }

  disconnectedCallback() {
    this.checkboxEl.removeEventListener('change', this.onChangeHandler);
  }

  init() {
    this.handleChange(this.checkboxEl.checked);
  }

  onChange(evt) {
    evt.preventDefault();

    this.handleChange(this.checkboxEl.checked);
  }

  handleChange(isActive) {
    requestAnimationFrame(() => {
      if (isActive) {
        //Toggle to lifestyle Image
        this.productGrid?.classList.add('lifestyle-view-active');
        //update text
        this.querySelector('.image-toggle-label>product-view').classList.add('hidden');
        this.querySelector('.image-toggle-label>lifestyle-view').classList.remove('hidden');
      } else {
        //Toggle to product Image
        this.productGrid?.classList.remove('lifestyle-view-active');
        //update text
        this.querySelector('.image-toggle-label>lifestyle-view').classList.add('hidden');
        this.querySelector('.image-toggle-label>product-view').classList.remove('hidden');
      }
    });
  }
}
customElements.define('image-toggle-switch', ImageToggleSwitch);